import getPropFromModule from './getPropFromModule';

const getIsUpdatingLines = state => getPropFromModule(state, 'isUpdetingLines');

export default getIsUpdatingLines;
